import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";

import { ISectorCubicleFilter } from "../models/filters/sectorCubicleFilter";
import { ISectorCubicleForm } from "../models/forms/sectorCubicleForm";
import { ISectorCubiclePDTO } from "../models/dtos/sectorCubiclePDTO";

// Service for SectorCubicle operations
export default class SectorCubicleService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/SectorCubicle";

    protected static override  getUrlFilter<F extends ISectorCubicleFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.sectorId != undefined)
                url += `&SectorId=${filter.sectorId}`;

            if(filter.cubicleId != undefined)
                url += `&CubicleId=${filter.cubicleId}`;
        }
        
        return url;
    }

    public static override toDTO(obj:ISectorCubicleForm):ISectorCubiclePDTO {
        const dto = super.toDTO(obj) as ISectorCubiclePDTO;
        return dto;
    }
}